
export const VENUE_TYPE_COLORS = {
  "Other": "#FF8C00",
  "Gas Stations": "#4285F4",
  "Medical / Health Clinic": "#EA4335",
  "Restaurants": "#FBBC04",
  "Automotive": "#1E40AF",
  "Gyms": "#34A853",
  "Veteran's Post": "#FBBC04",
  "Sports Facility": "#9C27B0",
  "Facility": "#9E9E9E",
  "Store": "#607D8B",
  "Barber Shop": "#E91E63",
  "Transit": "#FF5722",
  "Hotels": "#673AB7",
  "Financial": "#009688",
  "Education": "#3F51B5",
  "Outdoor Advertising": "#795548",
  "Liquor Store": "#8E24AA"
};

// Material Symbols for different venue types
export const VENUE_TYPE_ICONS = {
  "Other": "location_on",
  "Gas Stations": "local_gas_station",
  "Medical / Health Clinic": "local_hospital",
  "Restaurants": "restaurant",
  "Automotive": "build",
  "Gyms": "fitness_center",
  "Veteran's Post": "flag",
  "Sports Facility": "sports_basketball",
  "Facility": "apartment",
  "Store": "store",
  "Barber Shop": "content_cut",
  "Transit": "directions_bus",
  "Hotels": "hotel",
  "Financial": "account_balance",
  "Education": "school",
  "Outdoor Advertising": "campaign",
  "Liquor Store": "liquor"
};

export const venueTypes = ["All Types", ...Object.keys(VENUE_TYPE_COLORS)];